import i18n from '@/utils/i18n';
import React from 'react';
import { ChatTypingIndicator } from '@usepepper/sprout-kit-ui';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';

interface CopilotTypingBubbleProps {
  style?: StyleProp<ViewStyle>;
}

export const CopilotTypingBubble: React.FC<CopilotTypingBubbleProps> = ({
  style,
}) => {
  const [styles] = useStyles();

  return (
    <View
      accessibilityLabel={i18n.t('sales_portal.copilot.typing')}
      aria-busy
      style={[styles.row, style]}
    >
      <ChatTypingIndicator />
    </View>
  );
};

const useStyles = createStyles(() => ({
  row: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: '100%',
  },
}));
